import React from 'react'

const AbroadMERBLI = () => {
  return (
    <div className='container abroad-merbli-img'>
      <a href="mailto:info@phgfoundationafrica.org?subject=Applying for Abroad Project Monitoring %26 Evaluation">
        <button className='btn btn-primary'>Reach Us</button>
      </a>
    </div>
  )
}

export default AbroadMERBLI